import { render, staticRenderFns } from "./BinsDisplay.vue?vue&type=template&id=d361e7fa&scoped=true"
import script from "./BinsDisplay.vue?vue&type=script&lang=js"
export * from "./BinsDisplay.vue?vue&type=script&lang=js"
import style0 from "./BinsDisplay.vue?vue&type=style&index=0&id=d361e7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d361e7fa",
  null
  
)

export default component.exports